export default document;